import ApiService from '@/services/ApiService'

export const namespaced = true

export const state = {
  duties: [],
  dutiesMatching: [],
  dutiesType: [],
}

export const mutations = {
  SET_DUTIES(state, duties) {
    state.duties = duties
  },
  SET_DUTIES_MATCHING(state, dutiesMatching) {
    state.dutiesMatching = dutiesMatching
  },
  SET_DUTIES_TYPE(state, dutiesType) {
    state.dutiesType = dutiesType
  },
  ADD_DUTY(state, duty) {
    state.duties.push(duty)
  },
  EDIT_DUTY(state, duty) {
    const index = state.duties.findIndex(
      (el) => el.company_duty_uuid === duty.company_duty_uuid
    )
    if (index !== -1) {
      state.duties.splice(index, 1, duty)
    }
  },
  DELETE_DUTY(state, companyDutyUUID) {
    const index = state.duties.findIndex(
      (el) => el.company_duty_uuid === companyDutyUUID
    )
    if (index !== -1) state.duties.splice(index, 1)
  },
  ADD_DUTY_MATCHING(state, dutyMatching) {
    state.dutiesMatching.push(dutyMatching)
  },
  EDIT_DUTY_MATCHING(state, dutyMatching) {
    const index = state.dutiesMatching.findIndex(
      (el) =>
        el.company_duty_matching_uuid ===
        dutyMatching.company_duty_matching_uuid
    )
    if (index !== -1) {
      state.dutiesMatching.splice(index, 1, dutyMatching)
    }
  },
  DELETE_DUTY_MATCHING(state, companyDutyMatchingUUID) {
    const index = state.dutiesMatching.findIndex(
      (el) => el.company_duty_matching_uuid === companyDutyMatchingUUID
    )
    if (index !== -1) state.dutiesMatching.splice(index, 1)
  },
}

export const actions = {
  fetchDuties({ commit }, payload) {
    return ApiService.fetchDuties(payload)
      .then((res) => {
        const duties = res.data.data
        commit('SET_DUTIES', duties)
      })
      .catch((error) => {
        throw error
      })
  },
  fetchDutiesMatching({ commit }, companyUUID) {
    return ApiService.fetchDutiesMatching(companyUUID)
      .then((res) => {
        const dutiesMatching = res.data.data
        commit('SET_DUTIES_MATCHING', dutiesMatching)
      })
      .catch((error) => {
        throw error
      })
  },
  fetchDutiesType({ commit }) {
    return ApiService.fetchDutiesType()
      .then((res) => {
        const dutiesType = res.data.data
        commit('SET_DUTIES_TYPE', dutiesType)
      })
      .catch((error) => {
        throw error
      })
  },
  addDuty({ commit }, payload) {
    return ApiService.addDuty(payload)
      .then((res) => {
        const duty = res.data
        commit('ADD_DUTY', duty)
      })
      .catch((error) => {
        throw error
      })
  },
  editDuty({ commit }, payload) {
    return ApiService.editDuty(payload)
      .then((res) => {
        const duty = res.data
        commit('EDIT_DUTY', duty)
      })
      .catch((error) => {
        throw error
      })
  },
  deleteDuty({ commit }, payload) {
    return ApiService.deleteDuty(payload)
      .then(() => {
        commit('DELETE_DUTY', payload.companyDutyUUID)
      })
      .catch((error) => {
        throw error
      })
  },
  addDutyMatching({ commit }, payload) {
    return ApiService.addDutyMatching(payload)
      .then((res) => {
        const dutyMatching = res.data
        commit('ADD_DUTY_MATCHING', dutyMatching)
      })
      .catch((error) => {
        throw error
      })
  },
  editDutyMatching({ commit }, payload) {
    return ApiService.editDutyMatching(payload)
      .then((res) => {
        const dutyMatching = res.data
        commit('EDIT_DUTY_MATCHING', dutyMatching)
      })
      .catch((error) => {
        throw error
      })
  },
  deleteDutyMatching({ commit }, payload) {
    return ApiService.deleteDutyMatching(payload)
      .then(() => {
        commit('DELETE_DUTY_MATCHING', payload.companyDutyMatchingUUID)
      })
      .catch((error) => {
        throw error
      })
  },
}

export const getters = {}
